<template>
  <div id="all-assessments" class="sonar-assessments">
    <div class="sonar-assessments__header">
      <div class="sonar-assessments__info">
        <h5 class="sonar-assessments__title">All assessments</h5>
        <h6 class="sonar-assessments__subtitle">
          Unlock new levels by demonstrating your proficiency.
        </h6>
      </div>
      <SonarTabs v-if="userHasStats" />
    </div>

    <div v-if="isEnabled" class="sonar-assessments__groups-wrapper">
      <div
        v-for="(group, index) in assessments"
        :key="`sag-${index}`"
        class="sonar-assessments__cards-wrapper"
      >
        <div class="sonar-assessments__group-header">
          <img
            v-if="groupIcon(group)"
            :src="groupIcon(group)"
            class="sonar-assessments__group-icon"
            alt="Group icon"
          />
          <h4 class="sonar-assessments__group-name">
            {{ groupName(group) }}
          </h4>
        </div>

        <SonarAssessmentCard
          v-for="assessment in group.assessments"
          :key="assessment.id"
          :assessment="assessment"
          @show-mobile-alert-modal="showMobileAlertModal = true"
        />
      </div>
    </div>
    <div
      v-if="showMobileAlertModal"
      class="sonar-assessments__dialog-modal-wrapper"
    >
      <button
        class="dialog-modal__close sonar-dialog-modal__close"
        @click="showMobileAlertModal = false"
      >
        <XIcon class="dialog-modal__close--icon">clear</XIcon>
      </button>
      <div
        class="sonar-assessments__dialog-modal"
        @close-dialog-modal="showMobileAlertModal = false"
      >
        <p class="sonar-assessments__dialog-modal-title">
          We’re sorry, Sonar assessments aren’t available on mobile devices yet.
        </p>
        <p class="sonar-assessments__dialog-modal-info">
          To access Sonar assessments, please switch to a laptop or desktop
          computer.
        </p>
        <div
          class="sonar-assessments__actions-wrapper quiz-modal__dialog-modal-cta"
        >
          <button
            class="btn btn--primary sonar-assessments__dialog-modal-cta"
            @click="showMobileAlertModal = false"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SonarAssessmentCard from '@/sonar/components/SonarAssessmentCard.vue'
import SonarTabs from '@/sonar/components/SonarTabs.vue'
import { XIcon } from 'vue-feather-icons'
import { groupSetup } from '@/sonar/helpers/utils'

export default {
  name: 'SonarAssessments',
  components: {
    SonarAssessmentCard,
    SonarTabs,
    XIcon,
  },
  props: {
    assessments: {
      type: Array,
      required: true,
    },
    userHasStats: {
      type: Boolean,
      required: false,
    },
    isEnabled: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showMobileAlertModal: false,
    }
  },
  methods: {
    groupName(group) {
      const plural = group.assessments?.length > 1 ? 's' : ''
      return `${group.name} assessment${plural}`
    },
    groupIcon(group) {
      return groupSetup(group.slug)?.icon
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-assessments {
  margin-bottom: 80px;
  &__header {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    margin: 0 0 30px 0;
    @include mobile {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__title {
    color: var(--white);
    font-family: var(--font-bold);
    font-size: rem(20);
    margin: 0;
  }
  &__subtitle {
    color: var(--athens-gray);
    font-size: rem(16);
    line-height: rem(24);
    margin: 0;
  }
  &__groups-wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  &__group-header {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 2px;
  }
  &__group-name {
    margin: 0;
    color: var(--white);
    font-size: rem(16);
    line-height: rem(23);
  }
  &__group-icon {
    max-height: 26px;
    max-width: 26px;
  }
  &__cards-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__dialog-modal-wrapper {
    height: fit-content;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 300;
    display: flex;
    align-items: flex-end;
    border-radius: 20px 20px 0px 0px;
    background: var(--glass-mid-gray);
    background-color: var(--charcoal);
    padding: 30px;
  }
  &__dialog-modal {
    position: relative;
    background: transparent;
    width: 100%;
    color: var(--white);
    border-radius: 20px 20px 0px 0px;
    z-index: 300;
    &-title {
      font-size: rem(20);
      line-height: rem(26);
      font-weight: 700;
      margin: 34px 0 30px;
    }
    &-info {
      font-size: rem(14);
      line-height: rem(20);
      margin-bottom: 30px;
    }
    &-cta {
      width: 100%;
      height: 36px;
    }
  }
}
</style>
